import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './lib/contexts/auth-context';
import { ThemeProvider } from './lib/contexts/theme-context';
import { Toaster } from 'react-hot-toast';
import { ErrorBoundary } from './components/error-boundary';
import { RouteErrorBoundary } from './components/RouteErrorBoundary';
import { LoadingSpinner } from './components/LoadingSpinner';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardLayout from './pages/DashboardLayout';
import RootRedirect from './pages/RootRedirect';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <Suspense fallback={<LoadingSpinner fullScreen text="Loading application..." />}>
              <Routes>
                <Route 
                  path="/" 
                  element={
                    <RouteErrorBoundary routeName="Root">
                      <RootRedirect />
                    </RouteErrorBoundary>
                  } 
                />
                <Route 
                  path="/login" 
                  element={
                    <RouteErrorBoundary routeName="Login">
                      <LoginPage />
                    </RouteErrorBoundary>
                  } 
                />
                <Route 
                  path="/dashboard/*" 
                  element={
                    <RouteErrorBoundary routeName="Dashboard">
                      <DashboardLayout />
                    </RouteErrorBoundary>
                  } 
                />
                <Route path="*" element={<Navigate to="/login" replace />} />
              </Routes>
            </Suspense>
            <Toaster 
              position="top-right"
              containerStyle={{
                zIndex: 9999,
              }}
              toastOptions={{
                duration: 3000,
                style: {
                  background: 'var(--toast-bg)',
                  color: 'var(--toast-color)',
                },
              }}
            />
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
